import { Page } from '@app/components/page/Page';
import { Form } from '@mi-front/ui';
import { Upload as UploadIcon } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { UploadAssetField } from './components/UploadAssetField';

export function UploadPage() {
  const { $t } = useIntl();
  const uploadLabel = $t({
    id: 'assets.upload.label',
    defaultMessage: 'Subir recurso',
  });
  return (
    <Page htmlTitle={uploadLabel}>
      <Page.Header icon={<UploadIcon />} title={<span>{uploadLabel}</span>} />
      <Page.Content>
        <Form initialValues={{}} onSubmit={console.log}>
          <UploadAssetField
            inputProps={{
              label: $t({
                id: 'common.loadFile',
                defaultMessage: 'Cargar archivo',
              }),
              size: 'sm',
            }}
            name="upload.url"
          />
        </Form>
      </Page.Content>
    </Page>
  );
}
